import { useRef, useCallback } from 'react';
import type { Swiper as SwiperType } from 'swiper';

export const useCartSwiperManager = () => {
  const swiperInstancesRef = useRef<Map<number, React.RefObject<SwiperType | null>>>(new Map());

  // 注册一个Swiper实例
  const registerSwiper = useCallback(
    (id: number, swiperRef: React.RefObject<SwiperType | null>) => {
      swiperInstancesRef.current.set(id, swiperRef);
    },
    [],
  );

  // 注销一个Swiper实例
  const unregisterSwiper = useCallback((id: number) => {
    swiperInstancesRef.current.delete(id);
  }, []);

  // 关闭除指定ID外的所有其他Swiper
  const closeOthersSwiper = useCallback((currentCartId: number) => {
    swiperInstancesRef.current.forEach((swiperRef, cartId) => {
      if (cartId !== currentCartId && swiperRef.current) {
        try {
          swiperRef.current.slideTo(0, 200);
        } catch {
          // 忽略滑动错误，不影响其他功能
        }
      }
    });
  }, []);

  return {
    registerSwiper,
    unregisterSwiper,
    closeOthersSwiper,
  };
};
